import { useCalendarStyles } from '../Calendar.styles';
import { useLocale } from '../../../context/LocaleContext';
import { jsx as _jsx } from "react/jsx-runtime";
const DayButtonGrid = ({
  children
}) => /*#__PURE__*/_jsx("div", {
  style: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '2px'
  },
  children: children
});
const DayCell = ({
  children
}) => /*#__PURE__*/_jsx("div", {
  style: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px 0'
  },
  children: children
});
const dayFormatter = new Map();
function formatDayLabel(dateStr, locale) {
  if (!dayFormatter.has(locale)) {
    dayFormatter.set(locale, new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC'
    }));
  }
  return dayFormatter.get(locale).format(new Date(`${dateStr}T00:00:00Z`));
}
const CalendarDayGrid = ({
  calendarDays,
  availableDateSet,
  selectedDate,
  isDisabled,
  onDayClick
}) => {
  const {
    dayBtnStyle
  } = useCalendarStyles();
  const locale = useLocale();
  return /*#__PURE__*/_jsx(DayButtonGrid, {
    children: calendarDays.map((day, i) => {
      const key = day ? day.dateStr : `blank-${i}`;
      const available = day ? availableDateSet.has(day.dateStr) : false;
      const isSelected = day ? day.dateStr === selectedDate : false;
      return /*#__PURE__*/_jsx(DayCell, {
        children: day && /*#__PURE__*/_jsx("button", {
          "aria-label": formatDayLabel(day.dateStr, locale),
          "aria-pressed": isSelected,
          style: dayBtnStyle(available, isSelected, isDisabled),
          disabled: !available || isDisabled,
          onClick: () => onDayClick(day.dateStr),
          children: day.day.toLocaleString(locale)
        })
      }, key);
    })
  });
};
export default CalendarDayGrid;